function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient",
  x1: -26.01,
  y1: 66.01,
  x2: 200.64,
  y2: 66.01,
  gradientTransform: "matrix(-1 0 0 1 410.51 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec",
  stopOpacity: 0.4
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-2",
  x1: 15.15,
  y1: 74.41,
  x2: 189.48,
  y2: 74.41,
  xlinkHref: "#iceberg-ship_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-3",
  x1: 60.32,
  y1: 84.69,
  x2: 179.21,
  y2: 84.69,
  xlinkHref: "#iceberg-ship_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-4",
  x1: 176.15,
  y1: 6.76,
  x2: 128.3,
  y2: 181.26,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-5",
  x1: 140.11,
  y1: 96.56,
  x2: 136.16,
  y2: 126.06,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5c71b3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-6",
  x1: 152.76,
  y1: 165.8,
  x2: 249.96,
  y2: 68.6,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-7",
  x1: 194.45,
  y1: 107.89,
  x2: 181.59,
  y2: 73.02,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-8",
  x1: 107.91,
  y1: 161.11,
  x2: 179.87,
  y2: 95.62,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-9",
  x1: 151.16,
  y1: 115.13,
  x2: 237.68,
  y2: 62.61,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-10",
  x1: 186.87,
  y1: 92.95,
  x2: 184.69,
  y2: 55.03,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-11",
  x1: 115.82,
  y1: 104.35,
  x2: 184.69,
  y2: 91.49,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-12",
  x1: 222.33,
  y1: 49.58,
  x2: 191.14,
  y2: 49.58,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-13",
  x1: -4061.37,
  y1: 37.97,
  x2: -4061.37,
  y2: 26.15,
  gradientTransform: "translate(4265.97)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#454fa1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8e9dcf"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-14",
  x1: 199.89,
  y1: 60.28,
  x2: 171.76,
  y2: 60.28,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-15",
  x1: -4080.31,
  y1: 49.95,
  x2: -4080.31,
  y2: 36.68,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-16",
  x1: 178.09,
  y1: 70.99,
  x2: 151.5,
  y2: 70.99,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-17",
  x1: -4099.25,
  y1: 63.79,
  x2: -4099.25,
  y2: 47.88,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-18",
  x1: -4085.81,
  y1: 405.8,
  x2: -4090.39,
  y2: 328.65,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-19",
  x1: -4082.12,
  y1: 405.58,
  x2: -4086.7,
  y2: 328.43,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-20",
  x1: -4078.43,
  y1: 405.36,
  x2: -4083.01,
  y2: 328.21,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-21",
  x1: -4074.74,
  y1: 405.14,
  x2: -4079.32,
  y2: 327.99,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-22",
  x1: -4071.05,
  y1: 404.92,
  x2: -4075.63,
  y2: 327.77,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-23",
  x1: -4067.36,
  y1: 404.7,
  x2: -4071.94,
  y2: 327.55,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-24",
  x1: -4063.68,
  y1: 404.48,
  x2: -4068.25,
  y2: 327.34,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-25",
  x1: -4059.99,
  y1: 404.27,
  x2: -4064.56,
  y2: 327.12,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-26",
  x1: -4056.3,
  y1: 404.05,
  x2: -4060.87,
  y2: 326.9,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-27",
  x1: -4052.61,
  y1: 403.83,
  x2: -4057.18,
  y2: 326.68,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-28",
  x1: -4048.92,
  y1: 403.61,
  x2: -4053.49,
  y2: 326.46,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-29",
  x1: -4045.23,
  y1: 403.39,
  x2: -4049.8,
  y2: 326.24,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-30",
  x1: -4041.54,
  y1: 403.17,
  x2: -4046.11,
  y2: 326.02,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-31",
  x1: -4037.85,
  y1: 402.95,
  x2: -4042.42,
  y2: 325.8,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-32",
  x1: -4034.16,
  y1: 402.73,
  x2: -4038.73,
  y2: 325.58,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-33",
  x1: -4030.47,
  y1: 402.51,
  x2: -4035.04,
  y2: 325.37,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-34",
  x1: -4026.78,
  y1: 402.3,
  x2: -4031.35,
  y2: 325.15,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-35",
  x1: -4023.09,
  y1: 402.08,
  x2: -4027.66,
  y2: 324.93,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-36",
  x1: -4019.4,
  y1: 401.86,
  x2: -4023.97,
  y2: 324.71,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-37",
  x1: -4015.71,
  y1: 401.64,
  x2: -4020.28,
  y2: 324.49,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-38",
  x1: -4012.02,
  y1: 401.42,
  x2: -4016.59,
  y2: 324.27,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-39",
  x1: -4008.33,
  y1: 401.2,
  x2: -4012.91,
  y2: 324.05,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-40",
  x1: -4004.64,
  y1: 400.98,
  x2: -4009.22,
  y2: 323.83,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-41",
  x1: -4000.95,
  y1: 400.76,
  x2: -4005.53,
  y2: 323.61,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-42",
  x1: 273.47,
  y1: 100.88,
  x2: -36.77,
  y2: 266.44,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#8b9acd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#818fc7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#707dbc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#5964ad"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-43",
  x1: 17.85,
  y1: 199.94,
  x2: 109.86,
  y2: 152.48,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-44",
  x1: -20.06,
  y1: 226.12,
  x2: 93.37,
  y2: 145.68,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-45",
  x1: 104.3,
  y1: 166.93,
  x2: 47.88,
  y2: 166.93,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-46",
  x1: 53.52,
  y1: 106.59,
  x2: 72.59,
  y2: 210.93,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-47",
  x1: -4857.24,
  y1: 170.68,
  x2: -4839.7,
  y2: 140.29,
  gradientTransform: "translate(4920.1)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-48",
  x1: -4877.88,
  y1: 158.6,
  x2: -4860.33,
  y2: 128.21,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-47"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-49",
  x1: -4878.03,
  y1: 140.26,
  x2: -4860.53,
  y2: 170.58,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-47"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-50",
  x1: -4857.43,
  y1: 128.12,
  x2: -4839.85,
  y2: 158.56,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-47"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-51",
  x1: -4233.56,
  y1: 162.79,
  x2: -4231.08,
  y2: 158.24,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-52",
  x1: 376.58,
  y1: 158.38,
  x2: 377.47,
  y2: 158.38,
  gradientTransform: "matrix(-1 0 0 1 410.51 0)",
  xlinkHref: "#iceberg-ship_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-53",
  x1: -4230.46,
  y1: 164.48,
  x2: -4227.98,
  y2: 159.93,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-54",
  x1: 373.53,
  y1: 160.18,
  x2: 374.43,
  y2: 160.18,
  gradientTransform: "matrix(-1 0 0 1 410.51 0)",
  xlinkHref: "#iceberg-ship_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-55",
  x1: -4227.36,
  y1: 166.17,
  x2: -4224.88,
  y2: 161.62,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-56",
  x1: 370.49,
  y1: 161.97,
  x2: 371.38,
  y2: 161.97,
  gradientTransform: "matrix(-1 0 0 1 410.51 0)",
  xlinkHref: "#iceberg-ship_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-57",
  x1: -4224.26,
  y1: 167.86,
  x2: -4221.77,
  y2: 163.32,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-58",
  x1: -4223.43,
  y1: 163.98,
  x2: -4225.44,
  y2: 169.33,
  gradientTransform: "translate(4265.97)",
  xlinkHref: "#iceberg-ship_svg__linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-59",
  x1: -4221.15,
  y1: 169.56,
  x2: -4218.67,
  y2: 165.01,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-60",
  x1: 364.4,
  y1: 165.56,
  x2: 365.29,
  y2: 165.56,
  gradientTransform: "matrix(-1 0 0 1 410.51 0)",
  xlinkHref: "#iceberg-ship_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-61",
  x1: -4218.05,
  y1: 171.25,
  x2: -4215.57,
  y2: 166.7,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-62",
  x1: 361.35,
  y1: 167.36,
  x2: 362.24,
  y2: 167.36,
  gradientTransform: "matrix(-1 0 0 1 410.51 0)",
  xlinkHref: "#iceberg-ship_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-63",
  x1: -4214.95,
  y1: 172.94,
  x2: -4212.47,
  y2: 168.39,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-64",
  x1: -4213.65,
  y1: 167.66,
  x2: -4215.66,
  y2: 173.01,
  gradientTransform: "translate(4265.97)",
  xlinkHref: "#iceberg-ship_svg__linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-65",
  x1: -4211.85,
  y1: 174.63,
  x2: -4209.36,
  y2: 170.08,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-66",
  x1: 355.26,
  y1: 170.95,
  x2: 356.15,
  y2: 170.95,
  gradientTransform: "matrix(-1 0 0 1 410.51 0)",
  xlinkHref: "#iceberg-ship_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-67",
  x1: -4208.74,
  y1: 176.33,
  x2: -4206.26,
  y2: 171.78,
  xlinkHref: "#iceberg-ship_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-ship_svg__linear-gradient-68",
  x1: 352.21,
  y1: 172.75,
  x2: 353.1,
  y2: 172.75,
  gradientTransform: "matrix(-1 0 0 1 410.51 0)",
  xlinkHref: "#iceberg-ship_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "iceberg-ship_svg__clip-path"
}, /*#__PURE__*/React.createElement("path", {
  className: "iceberg-ship_svg__cls-1",
  d: "M161.02 160.03l85.25-49.22V69.8l-85.25 49.22v41.01z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "iceberg-ship_svg__clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "iceberg-ship_svg__cls-1",
  d: "M31.92 151.78L58.7 167.5a5.24 5.24 0 005.3 0l26.78-15.72a2.76 2.76 0 000-4.77L64 131.54a5.25 5.25 0 00-5.23 0L31.93 147a2.76 2.76 0 00-.01 4.78z"
})), /*#__PURE__*/React.createElement("style", null, ".iceberg-ship_svg__cls-1{fill:none}.iceberg-ship_svg__cls-15{fill:#f2f5fa}.iceberg-ship_svg__cls-46{fill:#101436}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "iceberg-ship_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "iceberg-ship_svg__Layer_4",
  "data-name": "Layer 4"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient)",
  d: "M209.86 99.98l54.92 32.05L436.51 31.61 381.6 0 209.86 99.98z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-2)",
  d: "M221.03 100.53l42.2 24.69 132.13-77.26-42.2-24.35-132.13 76.92z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-3)",
  d: "M231.3 102.5l28.78 16.83 90.1-52.68-28.78-16.61-90.1 52.46z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210 60L38.13 159.76C20.15 172.64 9 207.55 9 207.55s1.86-.07 5-.24c14-.78 53.71-3.66 73.1-12.16l166.77-96.52 10.93-6.33z",
  fill: "url(#iceberg-ship_svg__linear-gradient-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.13 181.81c-8 5.73-14.63 15.8-19.54 25.22 16.69-1.09 51-4.18 68.53-11.88l158.8-91.92L210 82.08z",
  fill: "url(#iceberg-ship_svg__linear-gradient-5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#23c386",
  d: "M161.02 160.03l85.25-49.22V69.8l-85.25 49.22v41.01z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-6)",
  d: "M161.02 160.03l85.25-49.22V69.8l-85.25 49.22v41.01z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-7)",
  d: "M246.27 69.8l-35.99-20.77-85.24 49.23 35.98 20.76 85.25-49.22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-8)",
  d: "M161.02 119.02l-35.98-20.76v41.01l35.98 20.76v-41.01z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-9)",
  d: "M164.92 111.81l69.14-39.92V59.77l-69.14 39.92v12.12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-10)",
  d: "M234.06 59.77L206.39 43.8l-69.14 39.92 27.67 15.97 69.14-39.92z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-11)",
  d: "M164.92 99.69l-27.67-15.97v12.12l27.67 15.97V99.69z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.94 32.81h21.31v27.28c0 1.61-1 3.23-3.11 4.46a16.67 16.67 0 01-15.07 0c-2.13-1.23-3.17-2.85-3.12-4.46z",
  fill: "url(#iceberg-ship_svg__linear-gradient-12)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "iceberg-ship_svg__cls-15",
  cx: 204.59,
  cy: 32.81,
  rx: 10.65,
  ry: 6.15
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 204.59,
  cy: 32.81,
  rx: 6.36,
  ry: 3.67,
  fill: "url(#iceberg-ship_svg__linear-gradient-13)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175 43.51h21.31v27.28c0 1.61-1 3.24-3.11 4.46a16.61 16.61 0 01-15.07 0C176 74 175 72.4 175 70.79z",
  fill: "url(#iceberg-ship_svg__linear-gradient-14)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "iceberg-ship_svg__cls-15",
  cx: 185.65,
  cy: 43.51,
  rx: 10.65,
  ry: 6.15
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 185.65,
  cy: 43.51,
  rx: 6.36,
  ry: 3.67,
  fill: "url(#iceberg-ship_svg__linear-gradient-15)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.06 54.22h21.31V81.5c0 1.61-1 3.23-3.11 4.46a16.67 16.67 0 01-15.07 0c-2.13-1.23-3.17-2.85-3.12-4.46z",
  fill: "url(#iceberg-ship_svg__linear-gradient-16)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "iceberg-ship_svg__cls-15",
  cx: 166.71,
  cy: 54.22,
  rx: 10.65,
  ry: 6.15
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 166.71,
  cy: 54.22,
  rx: 6.36,
  ry: 3.67,
  fill: "url(#iceberg-ship_svg__linear-gradient-17)"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#iceberg-ship_svg__clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-18)",
  d: "M163.24 86.71h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-19)",
  d: "M166.87 85.5h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-20)",
  d: "M170.5 84.29h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-21)",
  d: "M174.13 83.08h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-22)",
  d: "M177.76 81.87h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-23)",
  d: "M181.39 80.66h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-24)",
  d: "M185.02 79.45h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-25)",
  d: "M188.66 78.24h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-26)",
  d: "M192.29 77.02h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-27)",
  d: "M195.92 75.81h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-28)",
  d: "M199.55 74.6h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-29)",
  d: "M203.18 73.39h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-30)",
  d: "M206.81 72.18h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-31)",
  d: "M210.44 70.97h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-32)",
  d: "M214.07 69.76h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-33)",
  d: "M217.7 68.55h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-34)",
  d: "M221.33 67.34h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-35)",
  d: "M224.97 66.13h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-36)",
  d: "M228.6 64.92h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-37)",
  d: "M232.23 63.71h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-38)",
  d: "M235.86 62.5h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-39)",
  d: "M239.49 61.29h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-40)",
  d: "M243.12 60.08h1.21v88.35h-1.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-41)",
  d: "M246.75 58.87h1.21v88.35h-1.21z"
})), /*#__PURE__*/React.createElement("ellipse", {
  className: "iceberg-ship_svg__cls-46",
  cx: 143.78,
  cy: 93.28,
  rx: 1.42,
  ry: 2.46,
  transform: "rotate(-30 143.784 93.287)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "iceberg-ship_svg__cls-46",
  cx: 150.74,
  cy: 97.32,
  rx: 1.42,
  ry: 2.46,
  transform: "rotate(-30 150.745 97.312)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "iceberg-ship_svg__cls-46",
  cx: 157.71,
  cy: 101.36,
  rx: 1.42,
  ry: 2.46,
  transform: "rotate(-30 157.702 101.356)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M264.8 92.3l-10.93 6.33-8 4.6-158.75 91.92c-.58.25-1.18.5-1.8.74l-.62.24-1.27.48-.78.27-1.22.42-.86.28c-.4.13-.8.26-1.22.38l-.91.28-1.25.36-1 .26-1.19.34-1 .26-1.35.33-1 .23-1.47.34-.89.2-1.71.37-.71.15-2.45.49-.5.09L62 202l-.94.16-1.58.28-1 .17-1.5.25-1.08.17-1.46.23-1.11.16-1.44.21-1.11.16-1.46.2-1.07.14-1.53.2-1 .13-1.58.19-.93.11-1.87.22-.58.07-2.43.26-.65.07-1.72.18-.91.09-1.44.14-.93.09-1.33.12-1 .08-1.28.12-.9.07-1.23.11-.88.07-1.18.09-.84.07-1.16.08-.74.06-1.33.09h-.47l-1.73.12-4.57.28c-3.17.17-5 .24-5 .24v39.72s54.35-2 78.13-12.4L264.8 132V92.3z",
  fill: "url(#iceberg-ship_svg__linear-gradient-42)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.14 167.32l-13-7.53-19-11-18.92 11c-10.55 7.56-18.74 22.68-23.72 33.9L9 195.94v11.61s1.86-.07 5-.24l4.57-.28c16.69-1.09 51-4.18 68.53-11.88l25.08-14.52V169z",
  fill: "url(#iceberg-ship_svg__linear-gradient-43)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.1 148.18l-19-11-18.92 11C20.15 161 9 195.94 9 195.94s1.86-.07 5-.24c1.31-.07 2.85-.16 4.57-.28 16.69-1.09 51-4.18 68.53-11.88L112.2 169z",
  fill: "url(#iceberg-ship_svg__linear-gradient-44)"
}), /*#__PURE__*/React.createElement("path", {
  className: "iceberg-ship_svg__cls-46",
  d: "M132.98 112.27l-2.87-1.66v-3.31l2.87 1.65v3.32zm5.74 3.32l-2.87-1.66v-3.32l2.87 1.66v3.32zm5.75 3.31l-2.88-1.65v-3.32l2.88 1.66v3.31zm5.74 3.32l-2.87-1.66v-3.31l2.87 1.65v3.32zm5.74 3.32l-2.87-1.66v-3.32l2.87 1.66v3.32zm-22.97-6.64l-2.87-1.65v-3.32l2.87 1.66v3.31zm5.74 3.32l-2.87-1.66v-3.31l2.87 1.65v3.32zm5.75 3.32l-2.88-1.66v-3.32l2.88 1.66v3.32zm5.74 3.31l-2.87-1.66v-3.31l2.87 1.66v3.31zm5.74 3.32l-2.87-1.66v-3.32l2.87 1.66v3.32zm-22.97-6.63l-2.87-1.66v-3.32l2.87 1.66v3.32zm5.74 3.31l-2.87-1.66v-3.31l2.87 1.66v3.31zm5.75 3.32l-2.88-1.66v-3.32l2.88 1.66v3.32zm5.74 3.31l-2.87-1.65v-3.32l2.87 1.66v3.31zm5.74 3.32l-2.87-1.66v-3.31l2.87 1.65v3.32zm-22.97-6.63l-2.87-1.66v-3.32l2.87 1.66v3.32zm5.74 3.31l-2.87-1.65v-3.32l2.87 1.66v3.31zm5.75 3.32l-2.88-1.66v-3.31l2.88 1.65v3.32zm5.74 3.32l-2.87-1.66v-3.32l2.87 1.66v3.32zm5.74 3.31l-2.87-1.65v-3.32l2.87 1.66v3.31z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.55 149.53h61.59v15.92a2.71 2.71 0 01-1.35 2.45L64 183.61a5.24 5.24 0 01-5.3 0L31.92 167.9a2.7 2.7 0 01-1.36-2.45z",
  fill: "#9feed0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.55 149.53h61.59v15.92a2.71 2.71 0 01-1.35 2.45L64 183.61a5.24 5.24 0 01-5.3 0L31.92 167.9a2.7 2.7 0 01-1.36-2.45z",
  fill: "url(#iceberg-ship_svg__linear-gradient-45)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.92 151.78L58.7 167.5a5.24 5.24 0 005.3 0l26.78-15.72a2.76 2.76 0 000-4.77L64 131.54a5.25 5.25 0 00-5.23 0L31.93 147a2.76 2.76 0 00-.01 4.78z",
  fill: "url(#iceberg-ship_svg__linear-gradient-46)"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#iceberg-ship_svg__clip-path-2)",
  strokeWidth: 1.05,
  strokeMiterlimit: 10,
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "url(#iceberg-ship_svg__linear-gradient-47)",
  d: "M54.35 165.47l34.57-19.96"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#iceberg-ship_svg__linear-gradient-48)",
  d: "M33.72 153.38l34.56-19.95"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#iceberg-ship_svg__linear-gradient-49)",
  d: "M33.58 145.47l34.49 19.91"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#iceberg-ship_svg__linear-gradient-50)",
  d: "M54.15 133.34l34.63 20"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-51)",
  d: "M33.93 164.23l-.89-.53v-6.31l.89.53v6.31z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-52)",
  d: "M33.93 159.37l-.89-.53v-1.45l.89.53v1.45z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-53)",
  d: "M36.97 166.02l-.89-.52v-6.31l.89.52v6.31z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-54)",
  d: "M36.97 161.16l-.89-.52v-1.45l.89.52v1.45z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-55)",
  d: "M40.02 167.82l-.89-.53v-6.31l.89.53v6.31z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-56)",
  d: "M40.02 162.96l-.89-.53v-1.45l.89.53v1.45z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-57)",
  d: "M43.07 169.61l-.9-.52v-6.31l.9.53v6.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-58)",
  d: "M43.07 164.76l-.9-.53v-1.45l.9.53v1.45z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-59)",
  d: "M46.11 171.41l-.89-.53v-6.3l.89.52v6.31z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-60)",
  d: "M46.11 166.55l-.89-.52v-1.45l.89.52v1.45z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-61)",
  d: "M49.16 173.21l-.89-.53v-6.31l.89.53v6.31z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-62)",
  d: "M49.16 168.35l-.89-.53v-1.45l.89.53v1.45z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-63)",
  d: "M52.2 175l-.89-.53v-6.3l.89.52V175z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-64)",
  d: "M52.2 170.14l-.89-.52v-1.45l.89.52v1.45z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-65)",
  d: "M55.25 176.8l-.89-.53v-6.31l.89.53v6.31z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-66)",
  d: "M55.25 171.94l-.89-.53v-1.45l.89.53v1.45z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-67)",
  d: "M58.3 178.59l-.9-.52v-6.31l.9.53v6.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-ship_svg__linear-gradient-68)",
  d: "M58.3 173.74l-.9-.53v-1.45l.9.53v1.45z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M274.46 126.36L87.12 234.8C63.34 245.22 9 247.2 9 247.2l-9 .41",
  stroke: "#2d327e",
  strokeMiterlimit: 10,
  fill: "none"
})));

function SvgIcebergShip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 436.51 248.11"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/iceberg-ship.52d95cc3.svg";
export { SvgIcebergShip as ReactComponent };